import GridCellBase from '../GridCellBase';
import CellTreeItemView from './CellTreeItemView';

class CellTreeItem extends GridCellBase {
  constructor(row, column, value, parentElement, propsData, dataset, grid) {
    super(row, column, value, parentElement, propsData, dataset, grid);
  }

  getBaseComponent() { // cell에 그려질 기본 컴포넌트를 반환
    return CellTreeItemView;
  }

  getEventName() { // 컴포넌트 데이터 변경을 감지할 이벤트 이름
    return 'checked';
  }

  decoratePropsData(row, column, value, propsData) { // 컴포넌트의 초기 props 설정
    propsData.value = value;
  }

  setValue(value) { // 컴포넌트의 값을 변경 하는 함수
    if (this.getComponentInstance()) {
      this.getComponentInstance().setValue(value);
    }
  }

  getValueFromEvent(event) { // 이벤트로부터 실제 dataset을 변경할 value 를 반환
    return event;    
  }

  isSelectable() {
    return true;
  }

  bindEvents() {
    this.selectHandler = event => this.select();
    this.parentElement.addEventListener('click', this.selectHandler);
  }

  destroy() {
    if (this.selectHandler) {
      this.parentElement.removeEventListener('click', this.selectHandler);
      this.selectHandler = null;
    }
  }

  updateDataset(checked) {
    const rowIndex = this.getDatasetIndex();
    let command = null;
    const depth = this.dataset.data[rowIndex][this.columnName].depth;
    for (let i = rowIndex; i < this.dataset.data.length; i++) {
      const data = this.dataset.data[i][this.columnName];
      if (i > rowIndex && data.depth <= depth) {
        break;
      }
      if (data.checked !== null && data.checked !== checked) {
        if (!command) {
          const newData = _.clone(data);
          newData.checked = checked;
          command = {
            index: i,
            data: newData,
          };
        } else {
          data.checked = checked;
        }       
      }      
    }
    if (command) {
      this.dataset.setData(command.index, this.columnName, command.data);
    }
  }
}

export default CellTreeItem;
